const ANONYMITY_STATE = {
  NoPreference: { value: 0 },
  OptedIn: { value: 1 },
  OptedOut: { value: 2 }
};

type ANONYMITY_STATE = typeof ANONYMITY_STATE;

export default ANONYMITY_STATE;
